/**
 * The height of the app bar, in pixels
 */
export const APP_BAR_HEIGHT = 64;

/**
 * The app of the env bar, in pixels
 */
export const ENV_BAR_HEIGHT = 25;
